<template>
    <div id="ordermsg">
        <van-nav-bar
            title="交流信息"
            left-text="返回"
            left-arrow
            @click-left="clickback"/>
        <van-loading vertical v-if="loading"/>
        <van-row v-for="item in data" :key="item.id">
            <van-col span="14" :offset="item.to_shop ? '0': '10'">
                <van-cell
                    :title="item.to_shop ? item.vip_name: item.shop_name"
                    :label="item.message"/>
                <!-- <div :class="item.to_shop ? 'left': 'right'">
                    <div>{{ item.to_shop ? item.vip_name: item.shop_name }}</div>
                    <div>{{ item.message }}</div>
                </div> -->
            </van-col>
        </van-row>
    </div>
</template>

<script>
import { 
    List,
    Cell, 
    NavBar, 
    Row,
    Col,
    Loading } from 'vant';
import { MsgApi } from '@/api/message'
export default {
    components: {
        [NavBar.name]: NavBar,
        [List.name]: List,
        [Cell.name]: Cell,
        [Loading.name]: Loading,
        [Row.name]: Row,
        [Col.name]: Col
    },
    mounted() {
        this.getData()
    },
    data() {
        return {
            id: this.$route.params.id,
            loading: false,
            data: []
        }
    },
    methods: {
        getData() {
            var that = this
            that.loading = true
            const params = {
                order_style: 1,
                order_id: this.id,
                page_size: 5000
            }
            that.axios.get(MsgApi, { params: params}).then((ret) => {
                that.loading = false
                that.data = ret.results
                console.log(ret)
            }).catch(function (error) {
                that.loading = false
                console.log(error)
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/user`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
#ordermsg {
    .van-row {
        .left {
            background-color: black;
        }
        .right {
            background-color: green;
        }
    }
}
</style>